module.exports = __webpack_public_path__ + "img/c04_unittechaidtent_Normal_ua.30bef641.webp";